<template>

  <div v-bind="$attrs">

      <FormsAutocomplete 
          @onShowFormCreate="(value) => showFormCreate = value"
          v-model="model"  
          :item="collection"
          :label="label"
          :disabled="disabled"
          :error-messages="errorMessages"
          :dense="dense"
          :outlined="outlined"
          store-action="domainTeacherIndicator/ActionIndexVariationStatuses"
          :return-object="returnObject"
          :load-data="loadData"
          :show-add="showAdd"
          :columns="columns"
          :clearable="clearable"
          @change="(value) => emit('change', value)"
      />

    </div>
  </template>
  
  <script setup>
  
  import { ref, computed, defineEmits, defineProps } from 'vue'
  
  //Events
  const emit = defineEmits(['input', 'update:item'])
  
  //Props
  const props = defineProps({
        label: { type: String, default: 'Status de Variação'},
        disabled: { type: Boolean, required: false },
        dense: { type: Boolean, required: false },
        outlined: { type: Boolean, required: false },
        value: { type: [String, Number, Object, Array] },
        item: { type: Object, required: false },
        errorMessages: { type: Array, required: false },
        loadData: { type: Boolean, default: false },
        returnObject: { type: Boolean, default: false },
        showAdd: { type: Boolean, default: false },
        columns: { type: String, required: false },
        clearable: { type: Boolean, required: false }
    })
  
  const showFormCreate = ref(false)

  //Computed
  const model = computed({
    get: () => props.value,
    set: val => emit('input', val)
  })
  
  const collection = computed({
    get: () => props.item,
    set: val => emit('update:item', val)
  })
  
  const newModel = ref({})

  function newItem(val) {

    if(props.returnObject) {
      model.value = { ...val }
      collection.value = { ...val }
    } else {
      model.value = val.id
      collection.value = { id: val.id, name: val.name }
    }

    showFormCreate.value = false
  }

  </script>